import { useEffect, useState } from 'react';

const useIsIE11 = () => {
    const [isIE11, setIsIE11] = useState(false);
    useEffect(() => {
        if (window.document.documentMode) {
            setIsIE11(true);
        }
    }, []);
    return isIE11;
};

export default useIsIE11;
